module.exports = __webpack_public_path__ + "media/images/avatar/default-4b2a09776803c1c49e44b468e3482b42.png";